<script lang="ts">
    import {PortaroThemeContainer} from 'shared/theme';
    import {getInjector} from 'src/core';
    import type {MediaViewerFile} from 'src/features/media-viewer/lib/mv-types';
    import {createSingularFileViewerContext} from './lib/mv-context';
    import {MvImageCacheService} from './services/mv-image-cache.service';
    import MvViewedContent from './components/mv-viewed-content/MvViewedContent.svelte';

    export let file: MediaViewerFile;

    const imageCacheService = getInjector().getByClass(MvImageCacheService);

    createSingularFileViewerContext(file, imageCacheService);
</script>

<div class="kp-singular-file-viewer">
    <PortaroThemeContainer overrideThemeValue="light">
        <MvViewedContent/>
    </PortaroThemeContainer>
</div>

<style lang="less">
    @import (reference) "src/features/media-viewer/media-viewer.themes.less";
    @import (reference) "styles/portaro-erp.less";

    .kp-singular-file-viewer {
        .flex-grow();
        position: relative;
        height: 100%;

        .portaro-themed-variables-redefinition();
    }

    :global {
        .kp-singular-file-viewer .mv-viewed-content {
            background-color: @themed-body-bg;
            border: none !important;
            border-radius: 0 !important;
        }
    }
</style>